export enum ServiceType {
  TRADITIONAL = 1,
  ECOMMERCE = 2,
  ONBOARDING = 3
}
